import Vue from 'vue'
import { omit } from 'lodash'
import inform from '@/services/inform'
import { clearLabels } from './labels'
import { unselectVariant, selectVariant, resetVariant } from './variant'
import { updateVariants, resetVariants } from './variants'
import { addSignToList, removeSignFromList } from './signs'
import { resetSVG, fetchSVG } from './svg'

// State
const state = {
  isLoading: false,
  isDirty: false,
  isSaving: false,
  data: null
}

// Mutations
export const addArrow = 'addArrow'
export const addArrowSpectrum = 'addArrowSpectrum'
const fetchSignRequest = 'fetchSignRequest'
const fetchSignResponse = 'fetchSignResponse'
export const updateSign = 'updateSign'

const saveSignRequest = 'saveSignRequest'
const removeSignRequest = 'removeSignRequest'
const removeSignResponse = 'removeSignResponse'
const updateStatusRequest = 'updateStatusRequest'
const updateStatusResponse = 'updateStatusResponse'

const mutations = {
  [fetchSignRequest] (state) {
    state.isLoading = true
  },
  [fetchSignResponse] (state, sign) {
    state.isLoading = false
    state.isSaving = false
    state.isDirty = false
    state.data = sign
  },
  [updateSign] (state, data) {
    state.data = { ...state.data, ...data }
    state.isDirty = true
  },
  [saveSignRequest] (state) {
    state.isSaving = true
  },
  [removeSignRequest] (state) {},
  [removeSignResponse] (state) {
    inform(`Schild erfolgreich gelöscht`)
  },
  [updateStatusRequest] (state) {
    state.isSaving = true
  },
  [updateStatusResponse] (state) {
    state.isSaving = false
  },
  [addArrow] (state, { index, value }) {
    const current = [...(state.data.arrows || [])]
    current[index] = value
    state.data.arrows = current
  },
  [addArrowSpectrum] (state, { index, value }) {
    const current = [...(state.data.arrowSpectrum || [])]
    current[index] = value
    state.data.arrowSpectrum = current
  }
}

// Actions
export const fetchSign = 'fetchSign'
export const saveSign = 'saveSign'
export const removeSign = 'removeSign'
export const resetSign = 'resetSign'
export const updateStatus = 'updateStatus'
export const transferSign = 'transferSign'

const actions = {
  [fetchSign]: ({ commit, dispatch }, { id }) => {
    commit(clearLabels)
    dispatch(unselectVariant)
    commit(resetSVG)
    commit(fetchSignRequest)
    return Vue.http.get(`${SERVER_URL}/signs/${id}`).then(({ data: sign }) => {
      if (!sign.arrowSpectrum) {
        sign.arrowSpectrum = []
      }
      commit(fetchSignResponse, sign)
      commit(updateVariants, sign.variants)
      let variant = sign.variants.find(({ isDefault }) => isDefault)
      if (!variant) {
        console.warn('No default variant defined, selecting first in list')
        variant = sign.variants[0]
      }
      dispatch(selectVariant, variant)
      dispatch(fetchSVG, { svgPath: sign.signType.svgPath })
    })
  },

  [resetSign]: ({ commit, dispatch }) => {
    commit(clearLabels)
    dispatch(unselectVariant)
    commit(resetVariant)
    commit(resetSVG)
    commit(resetVariants)
    commit(fetchSignResponse, null)
  },

  [saveSign]: ({ commit, state, rootState, dispatch }, sign) => {
    commit(saveSignRequest)

    const xhr = () => {
      // UPDATE
      if (sign.id) {
        return Vue.http.put(
          `${SERVER_URL}/signs/${sign.id}`,
          omit(sign, 'variants')
        )
      } else {
        // CREATE
        sign.createdById = rootState.user.data.id
        sign.statusId = 1
        return Vue.http.post(`${SERVER_URL}/signs`, sign)
      }
    }

    return xhr().then(({ data: sign }) => {
      commit(fetchSignResponse, sign)
      commit(addSignToList, sign)
      return sign
    })
  },

  [removeSign]: ({ commit, dispatch }, sign) => {
    const { id } = sign
    commit(removeSignRequest)
    return Vue.http.delete(`${SERVER_URL}/signs/${id}`).then(() => {
      commit(removeSignResponse)
      commit(removeSignFromList, sign)
    })
  },

  [updateStatus]: ({ commit, dispatch }, { sign, status }) => {
    commit(updateStatusRequest)
    return Vue.http
      .put(`${SERVER_URL}/status/${sign.id}`, {
        statusId: status.id
      })
      .then(({ data: sign }) => {
        commit(updateStatusResponse)
        commit(fetchSignResponse, sign)
      })
  },
  [transferSign]: ({ commit, dispatch, state, rootState }, statusName) => {
    const status = rootState.status.data.find(({ name }) => name === statusName)
    dispatch(updateStatus, { sign: state.data, status })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sign.js